import { useEffect, useState } from 'react';
import { tokenService } from '@aimsos/auth';
import { ChatWebSocketFacade } from './chatWebSocketFacade.js';

/**
 * One facade instance per ShellLayout mount; connects when `VITE_WEBSOCKET_URL` is set and a token exists.
 */
export function useChatWebSocketFacade() {
  const [facade] = useState(() => new ChatWebSocketFacade());
  const wsUrl = (import.meta.env.VITE_WEBSOCKET_URL || '').replace(/\/+$/, '');

  useEffect(() => {
    if (!wsUrl) return undefined;

    facade.configure({
      url: wsUrl,
      getToken: () => tokenService.getToken(),
      refreshToken: async () => {
        const userUuid = localStorage.getItem('user_uuid') || undefined;
        const tenantUuid = localStorage.getItem('workspace_uuid') || undefined;
        return tokenService.refreshToken(userUuid, tenantUuid);
      },
      onTokenChange: (cb) => tokenService.onTokenChange(cb),
    });

    if (tokenService.getToken()) {
      facade.connect();
    }

    return () => {
      facade.disconnect();
    };
  }, [facade, wsUrl]);

  return { wsService: wsUrl ? facade : null, hasWsUrl: Boolean(wsUrl) };
}
